import root from "../../../src/root";
import { ClassroomAppContent } from "./components/AppContent/ClassroomAppContent";
import { classroomSiteOidc } from "./utils/oidcConfig";

root(ClassroomAppContent, classroomSiteOidc);
